// tslint:disable:max-line-length

import React from 'react';

export const UtilityCalculator = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.5,8.5v7h-7v-7H7.5z M15.5,8.5v7h-7v-7H15.5z M5.4,9.9L4,11.3L2.6,9.9l-0.7,0.7L3.3,12l-1.4,1.4l0.7,0.7 L4,12.7l1.4,1.4l0.7-0.7L4.7,12l1.4-1.4L5.4,9.9z M14.5,12.5h-5v1h5V12.5z M14.5,10.5h-5v1h5V10.5z M7.5,0.5v7h-7v-7H7.5z M15.5,0.5 v7h-7v-7H15.5z M4.5,1.5h-1v2h-2v1h2v2h1v-2h2v-1h-2V1.5z M14.5,3.5h-5v1h5V3.5z" />
    </svg>
  );
};
